import { useEffect } from "react";
import { myHeaders } from "../config/axios";
import { URL_API } from "../config/default";
import { useParams } from "react-router-dom";

const Modo = () => {
  const { modo } = useParams();
  const onModo = async (mode: any) => {
    let formdata = new FormData();
    formdata.append("mode", mode == "owner" ? "tenant" : "owner");
    const requestOptions = {
      method: "PUT",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/auth/me`, requestOptions)
      .then(async (result) => {
        const response = await result.json();
        localStorage.removeItem("token");
        localStorage.setItem("token", response?.token);

        if(mode == "owner") return (window.location.href = "/dashboard");
        if(mode == "tenant") return (window.location.href = "/");
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    onModo(modo);
  }, []);

  return "";
};

export default Modo;
